import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Optional,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { IBaseInputContract } from '../contracts/base-input';

@Component({
  selector: 'itl-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['../_templates/text-input-template/text-input-template-alb-class.scss', 'textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextareaComponent implements IBaseInputContract, AfterViewInit, ControlValueAccessor {
  @Input() public title: string;
  @Input() public placeholder = '';
  @Input() public icon: string;
  // Zeigt einen roten Stern neben dem Titel an
  @Input() public required = false;
  // Zeigt einen Counter der die noch möglichen Zeichen anzeigt
  @Input() public maxlength: number;
  @Input() public description: string;
  @Input() public preventEnter = false;
  @Input() public hideDelete = false;

  @ViewChild('textInput', { static: true }) textInput: ElementRef;

  public value = '';
  private onChange = (text: string) => {};
  private onTouched = () => {};

  constructor(
    @Optional() public ngControl: NgControl,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    if (this.ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.textInput.nativeElement.style.height = 'auto';
      this.textInput.nativeElement.style.height = `${this.textInput.nativeElement.scrollHeight}px`;
    }, 100);
  }

  public setFocus() {
    this.textInput.nativeElement.focus();
    this.markAsTouched();
  }

  public markAsTouched() {
    this.onTouched();
  }

  public updateChanges() {
    if (this.preventEnter && this.value) {
      this.value = this.value.replace(/(\r\n|\n|\r)/gm, '');
    }
    this._changeDetectorRef.detectChanges();
    this.onChange(this.value);
  }

  // ControlValueAccessor interface
  public writeValue(obj: any) {
    this.value = obj;
    this.updateChanges();
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public prevent(event) {
    if (this.preventEnter) {
      event.preventDefault();
    }
  }
  public removeSelected($event): void {
    if ($event) {
      $event.stopPropagation();
    }
    this.writeValue(null);
    this.onChange(this.value);
  }
}
